import React, { useState, useEffect } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import "./JumboPay.scss";

const WithdrawTable = () => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const [feeSettings, setFeeSettings] = useState([]);
  const fetchJumboFeeSettings = async () => {
    const response = await apiRequest(
      "Transactions",
      "GetJumbopayFeesSettings"
    );
    if (response.status === "success") {
      setFeeSettings(response.data);
    }
  };
  useEffect(() => {
    fetchJumboFeeSettings();
  }, []);

  return (
    <div className="level-table">
      <p className="table-explenation">
        {getTextByKey("aboutjumbopay-withdrawal-fee")}
      </p>
      <div className="levels">
        <div className="level">
          <div className="level-explenation long">
            {getTextByKey("aboutjumbopay-four-section-text-3")
              .replace(
                "#withdraw-limit-fee#",
                feeSettings.WithdrawalMinAmountForFixedFeeInILS
              )
              .replace("#currency#", "₪")}
          </div>
          <div className="level-percentage long">
            {getTextByKey("aboutjumbopay-four-section-free")}
          </div>
        </div>
        <div className="level">
          <div className="level-explenation long">
            {getTextByKey("aboutjumbopay-four-section-text-4")
              .replace(
                "#withdraw-limit-fee#",
                feeSettings.WithdrawalMinAmountForFixedFeeInILS
              )
              .replace("#currency#", "₪")}
          </div>
          <div className="level-percentage long">
            {" "}
            {parseInt(feeSettings.WithdrawalFixedFeeInILS).toFixed(2)}₪
          </div>
        </div>
      </div>
      <p className="comments">
        <small>{getHtmlByKey("aboutjumbopay-four-section-text-comment")}</small>
      </p>
    </div>
  );
};

export default WithdrawTable;
